<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters>
        <v-img :src="`${this.poster.downloadURL}`" alt>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-row>
    </v-container>

    <br />
    <v-container class="grey lighten-5">
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{
            this.poster.title
          }}</v-list-item-title>
          <v-list-item-subtitle
            >by
            <span v-for="author in this.poster.authors" :key="author.key"
              >{{ author }},
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <br />
      <v-row>
        <v-chip v-for="tag in this.poster.tags" :key="tag.key" class="ma-2">
          {{ tag }}
        </v-chip>
      </v-row>
      <v-row>
        <Rating />
      </v-row>
      <br />
      <v-row cols="12">
        <p class="text-justify">
          119 Views
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="mr-8">
              <v-icon v-on="on" title="Views">mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Tooltip</span>
        </v-tooltip>

        <v-btn icon class="mr-4">
          <v-icon title="Bookmark">mdi-bookmark-plus</v-icon>
        </v-btn>
        <v-btn icon class="mr-4">
          <a target="_blank" :href="this.linkedInLink">
            <v-icon title="LinkedIn">mdi-linkedin</v-icon>
          </a>
        </v-btn>
        <v-btn icon class="mr-4">
          <a target="_blank" :href="this.facebookLink">
            <v-icon title="Facebook">mdi-facebook</v-icon>
          </a>
        </v-btn>
        <v-btn icon class="mr-4">
          <a target="_blank" :href="this.twitterLink">
            <v-icon title="Twitter">mdi-twitter</v-icon>
          </a>
        </v-btn>
        <button
          class="mr-4"
          type="button"
          v-clipboard:copy="value"
          v-clipboard:success="onCopy"
          v-clipboard:error="onCopyError"
          @click="snackbar = true"
        >
          <a href="#" v-on:click.prevent>
            <v-icon title="Permalink">mdi-link</v-icon>
          </a>
        </button>
        <v-btn icon>
          <a download target="_blank" :href="this.poster.downloadURL">
            <v-icon title="Download">mdi-download</v-icon>
          </a>
        </v-btn>
      </v-row>
      <br />
      <p class="text-justify">
        {{ this.poster.description }}
      </p>
      <qrcode-vue :value="value" :size="size" level="H"></qrcode-vue>
      <div id="commento"></div>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :color="copySucceeded ? 'success' : 'error'"
    >
      {{
        copySucceeded ? "This link was copied!" : "This link was not copied..."
      }}
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Rating from "../components/Rating";
import QrcodeVue from "qrcode.vue";

export default {
  name: "Poster",
  components: { Rating, QrcodeVue },
  data: () => ({
    id: null,
    value: "",
    twitterLink: "",
    facebookLink: "",
    linkedInLink: "",
    size: 300,
    copySucceeded: null,
    snackbar: false
  }),
  computed: {
    ...mapGetters(["poster"])
  },
  mounted() {
    let posterId = this.$route.params.id;
    this.$store.dispatch("getPoster", posterId);

    // COMMENTO PLUGIN
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://cdn.commento.io/js/commento.js"
    );
    document.head.appendChild(recaptchaScript);

    this.value = "posterday.club" + this.$route.fullPath;

    this.twitterLink =
      "https://twitter.com/intent/tweet?text=" +
      "Check out my poster on " +
      "https://www.posterday.club" +
      this.$route.fullPath +
      "%20%40akinhwan%20" +
      "%23posterday %23posterpresentation %23posters %23science";

    this.facebookLink =
      "http://www.facebook.com/share.php?u=https://www.posterday.club" +
      this.$route.fullPath;

    // TODO escape id
    this.linkedInLink =
      `https://www.linkedin.com/shareArticle?mini=true` +
      `&url=https://www.posterday.club${this.$route.fullPath}` +
      `&title=PosterDay%20Club&summary=Poster%20Day%20Club&source=PosterDay`;
  },
  methods: {
    onCopy() {
      this.copySucceeded = true;
      this.snackbar = true;
    },
    onCopyError() {
      this.copySucceeded = false;
      this.snackbar = false;
    }
  }
};
</script>

<style></style>
